import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        component: () => import('@/pages/index')
    },
    {
        path: '/order/:orderid?',
        component: () => import('@/pages/orderDetail')
    },
    {
        path: '/test',
        component: () => import('@/pages/test.vue')
    },
    {
        path: '/invite',
        component: () => import('@/pages/inviteDetail')
    },
    {
        path: '/admin/:pass?',
        component: () => import('@/pages/admin')
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router;